<template>
    <methods-component :activeMethods="activeMethods" :archivedMethods="archivedMethods" @viewMethod="handleViewMethod" @editMethod="handleEditMethod" @duplicateMethod="handleDuplicateMethod" @archiveMethod="handleArchiveMethod" @completeMethod="handleCompleteMethod"></methods-component>
</template>


<script>
import MethodsComponent from '@/components/method/MethodsComponent'
import axios from "axios";
import { mapGetters, mapMutations } from 'vuex'

export default {
    name: "Methods",
    components: { MethodsComponent},
    computed: {
        ...mapGetters([
            'base_url', 'auth_header'
        ]),
    },
    data: function() {
        return {
            component_url: 'experiments/methods',
            activeMethods: [],
            archivedMethods: []
        }
    },
    methods: {
        ...mapMutations([
            'SET_BREADCRUMB'
        ]),
        setBreadcrumb: function(){
            this.SET_BREADCRUMB(this.$route.meta.breadcrumb)
        },
        getActiveMethods: function() {
            axios
                .get(`${this.base_url}${this.component_url}?archived=False`, {
                    headers: this.auth_header
                })
                .then(response => {
                    this.activeMethods = response.data;
                    console.log("Active method json: ")
                    console.log(this.activeMethods)
                })
                .catch(error => {
                    console.log("Something went wrong getting the methods : ", error.response.data);
                });
        },
        getArchivedMethods: function() {
            axios
                .get(`${this.base_url}${this.component_url}?archived=True`, {
                    headers: this.auth_header
                })
                .then(response => {
                    this.archivedMethods = response.data
                })
                .catch(error => {
                    console.log("Something went wrong getting the archived methods : ", error.response.data);
                });
        },
        handleViewMethod: function(currentMethod) {
            this.$router.push({ name: "ViewMethod", params: { id: currentMethod.id } });
        },
        handleEditMethod: function(currentMethod) {
            this.$router.push({ name: "EditMethod", params: { id: currentMethod.id } });
        },
        handleCompleteMethod: function(currentMethod) {
            axios
                .patch(`${this.base_url}${this.component_url}/${currentMethod.id}/`,
                    {status: "COMPLETED"},
                    { 
                        headers: this.auth_header
                    }
                )
                .then(response => {
                    console.log("Method Successfully Completed:", currentMethod);
                    this.loading = false;
                    this.$toast.open({
                        duration: 5000,
                        message: `Method Successfully Completed`,
                        position: 'is-top',
                        type: 'is-primary'
                    })
                    this.getActiveMethods();
                    this.getArchivedMethods();
                })
                .catch(error => {
                    this.loading = false;
                    this.$toast.open({
                        duration: 5000,
                        message: `Method was not successfully Completed`,
                        position: 'is-top',
                        type: 'is-danger'
                    })
                    console.log("Method was not successfully Completed: ", error.response.data);
                    this.getActiveMethods();
                    this.getArchivedMethods();
                });
        },
        handleArchiveMethod: function(currentMethod){
            axios
                .patch(`${this.base_url}${this.component_url}/${currentMethod.id}/archive/`,
                    {},
                    { 
                        headers: this.auth_header
                    }
                )
                .then(response => {
                    console.log("Method Successfully Archived:", currentMethod);
                    this.loading = false;
                    this.$toast.open({
                        duration: 5000,
                        message: `Method Successfully Archived`,
                        position: 'is-top',
                        type: 'is-primary'
                    })
                    this.getActiveMethods();
                    this.getArchivedMethods();
                })
                .catch(error => {
                    this.loading = false;
                    this.$toast.open({
                        duration: 5000,
                        message: `Method was not successfully Archived`,
                        position: 'is-top',
                        type: 'is-danger'
                    })
                    console.log("Method was not successfully Archived: ", error.response.data);
                    this.getActiveMethods();
                    this.getArchivedMethods();
                });
        },
        handleDuplicateMethod: function(currentMethod) {   
            var method_id =  currentMethod.id 
            delete currentMethod.id    
            currentMethod.analytes.forEach(analyte => {
                if(analyte.id){
                    delete analyte.id
                }                
            })            
            axios
                .post(
                    `${this.base_url}${this.component_url}/${method_id}/duplicate/`,
                    currentMethod,
                    { 
                        headers: this.auth_header
                    }
                )
                .then(() => {
                    console.log("Analytical method Successfully Duplicated!");
                    this.loading = false;
                    this.$toast.open({
                        duration: 5000,
                        message: `Analytical method Successfully Duplicated!`,
                        position: 'is-top',
                        type: 'is-primary'
                    })
                    this.getActiveMethods()
                })
                .catch(error => {
                    this.loading = false;
                    this.$toast.open({
                        duration: 5000,
                        message: `Analytical method was not successfully Duplicated!`,
                        position: 'is-top',
                        type: 'is-danger'
                    })
                    console.log("Analytical method was not successfully Duplicated!", error.response.data);
                });
        }
    },
    mounted: function(){        
        this.setBreadcrumb()
        this.getActiveMethods()
        this.getArchivedMethods()
    }
}
</script>